// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_comp_financials.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse } from "./stcs_commons.entity";

export const protobufPackage = "stcs_cmw";

export interface CompFssFlatGetRequest {
  ref_id_user: string;
  ref_id_comp: string;
}

export interface CompActualsResValuesGetRequest {
  ref_id_user: string;
  ref_id_comp: string;
}

function createBaseCompFssFlatGetRequest(): CompFssFlatGetRequest {
  return { ref_id_user: "", ref_id_comp: "" };
}

export const CompFssFlatGetRequest: MessageFns<CompFssFlatGetRequest> = {
  encode(message: CompFssFlatGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(18).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompFssFlatGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompFssFlatGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompFssFlatGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: CompFssFlatGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompFssFlatGetRequest>, I>>(base?: I): CompFssFlatGetRequest {
    return CompFssFlatGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompFssFlatGetRequest>, I>>(object: I): CompFssFlatGetRequest {
    const message = createBaseCompFssFlatGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseCompActualsResValuesGetRequest(): CompActualsResValuesGetRequest {
  return { ref_id_user: "", ref_id_comp: "" };
}

export const CompActualsResValuesGetRequest: MessageFns<CompActualsResValuesGetRequest> = {
  encode(message: CompActualsResValuesGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(18).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompActualsResValuesGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompActualsResValuesGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompActualsResValuesGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: CompActualsResValuesGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompActualsResValuesGetRequest>, I>>(base?: I): CompActualsResValuesGetRequest {
    return CompActualsResValuesGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompActualsResValuesGetRequest>, I>>(
    object: I,
  ): CompActualsResValuesGetRequest {
    const message = createBaseCompActualsResValuesGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

export interface StcsWappSvcCompFinancials {
  comp_fss_flat_get(
    request: DeepPartial<CompFssFlatGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_actuals_res_values_get(
    request: DeepPartial<CompActualsResValuesGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
}

export class StcsWappSvcCompFinancialsClientImpl implements StcsWappSvcCompFinancials {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.comp_fss_flat_get = this.comp_fss_flat_get.bind(this);
    this.comp_actuals_res_values_get = this.comp_actuals_res_values_get.bind(this);
  }

  comp_fss_flat_get(
    request: DeepPartial<CompFssFlatGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompFinancialscomp_fss_flat_getDesc,
      CompFssFlatGetRequest.fromPartial(request),
      metadata,
    );
  }

  comp_actuals_res_values_get(
    request: DeepPartial<CompActualsResValuesGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompFinancialscomp_actuals_res_values_getDesc,
      CompActualsResValuesGetRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcCompFinancialsDesc = { serviceName: "stcs_cmw.StcsWappSvcCompFinancials" };

export const StcsWappSvcCompFinancialscomp_fss_flat_getDesc: UnaryMethodDefinitionish = {
  methodName: "comp_fss_flat_get",
  service: StcsWappSvcCompFinancialsDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompFssFlatGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompFinancialscomp_actuals_res_values_getDesc: UnaryMethodDefinitionish = {
  methodName: "comp_actuals_res_values_get",
  service: StcsWappSvcCompFinancialsDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompActualsResValuesGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
